module.exports = __webpack_public_path__ + "static/media/Rubik-Light.6515f045.woff2";